import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Button,
  Modal,
  Space,
  Select,
  Row,
  Checkbox,
  Tabs,
  Radio,
  TimePicker,
  DatePicker,
  Spin,
  message,
  InputNumber,
  ConfigProvider,
  Segmented,
  Divider,
} from "antd";
// import { EditTwoTone } from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  getAllPostTasks,
  getAllPreTasks,
  getAllTasksDetails,
  updateTask,
} from "../Actions/tasksAction";
import "./styles/clients.css";
import { useBreakpoints } from "../components/ResponsiveBreakPoints";
import moment from "moment";
import MyTable from "../components/table";
import { createLeadNotes, getAllLeadNotes } from "../Actions/leadNotesAction";
import {
  createSiteVisitDetails,
  getSiteVisiteDetails,
} from "../Actions/siteVisitDetailsAction";
import editIcon from "../assets/images/editIcon.svg";
import { LoadingOutlined } from "@ant-design/icons";
import {
  getAllLeads,
  getLeadById,
  getleadtype,
  updateLead,
} from "../Actions/leadsActions";
import { getBirthdate } from "../Actions/birthdateAction";

const schema = Yup.object().shape({
  due_date: Yup.string().required("Required"),
});
const noteSchema = Yup.object().shape({
  text: Yup.string().required("Note is required"),
});
const siteSchema = Yup.object().shape({
  visit_time: Yup.mixed().required("Visit time is required"),
  visit_date: Yup.mixed().required("Visit date is required"),
  note: Yup.string().required("Note is required"),
});

const { TextArea } = Input;
const { Text } = Typography;
export const UpdatTask = ({
  id,
  type,
  flag,
  taskOpen,
  setTaskOpen,
  attachment_type,
  setPopoverVisible,
  popoverVisible,
  leadId,
  selectedTab,
  page,
  // the_lead
}) => {
  const { TabPane } = Tabs;
  const { isMobile, isTablet } = useBreakpoints();
  const [taskType, setTaskType] = useState("");

  const ClientType = [
    { value: 0, label: "Buyer" },
    { value: 1, label: "Seller" },
    { value: 2, label: "Rent Owner" },
    { value: 3, label: "Rent Client" },
  ];
  const Zone = [
    { value: 1, label: "R1" },
    { value: 2, label: "R2" },
    { value: 3, label: "R3" },
  ];
  const LeadStatus = [
    { value: "Warm", label: "Warm" },
    { value: "Hot", label: "Hot" },
    { value: "Cold", label: "Cold" },
    { value: "Dead", label: "Dead" },
    { value: "Success", label: "Success" },
  ];
  const LeadAreaType = [
    { value: 1, label: "SqFt" },
    { value: 2, label: "Yard" },
  ];
  const dispatch = useDispatch();
  const { users, currentUser } = useSelector((state) => state.users);

  const hasLeadEditPermission = useMemo(() => {
    if (!currentUser) return false;
    if (currentUser.role === "Admin") return true;
    return currentUser.permissions?.some(
      (p) => p.resource === "leads" && p.action === "update",
    );
  }, [currentUser]);

  const hasLeadShowPermission = useMemo(() => {
    if (!currentUser) return false;
    if (currentUser.role === "Admin") return true;
    return currentUser.permissions?.some(
      (p) => p.resource === "leads" && p.action === "show",
    );
  }, [currentUser]);

  const maskSensitiveVal = (val) => {
    if (hasLeadShowPermission) return val || "-";
    return "••••••••";
  };

  const handleUpdateTask = (data, event = null) => {
    if (event) event.preventDefault();
    data.id = id;
    dispatch(updateTask(data, successTaskUpdate, type));
    resetNote(data);
  };

  const fetchActiveTaskQuery = () => {
    const params = new URLSearchParams();
    params.append("page", page || 1);
    params.append("items", 10);
    if (selectedTab) params.append("date_filter", selectedTab);
    return `/tasks?${params.toString()}`;
  };

  const successTaskUpdate = () => {
    dispatch(getAllTasksDetails(fetchActiveTaskQuery(), successTask));
    dispatch(getBirthdate());
  };

  let allTasks = [];
  const {
    preTask,
    postTask,
    allTaskDetails,
    isUpdateTaskLoading,
    isGetAllTaskDetailsLoading,
  } = useSelector((state) => state.tasks);

  const { leadNotes, isCreateLeadNotesLoading, isGetLeadNotesLoading } =
    useSelector((state) => state.leadNotes);
  const {
    siteVisitDetails,
    isGetSiteVisitDetailsLoading,
    isCreateSiteVisitDetailsLoading,
  } = useSelector((state) => state.siteVisitDetails);
  const { isGetLeadsLoading, isGetLeadByIdLoading } = useSelector(
    (state) => state.leads,
  );
  if (type === "pre") {
    allTasks = preTask;
  } else if (type === "post") {
    allTasks = postTask;
  } else {
    allTasks = allTaskDetails;
  }

  const taskFromStore = allTasks.find((task) => task.id === id);

  const the_task = useMemo(() => {
    return taskFromStore
      ? {
          ...taskFromStore,
          user_id: taskFromStore.user?.id,
          due_date: formatDate(taskFromStore.due_date),
          communication_date: formatDate(taskFromStore.communication_date),
          follow_up_date: formatDate(taskFromStore.follow_up_date),
          site_visit_date: formatDate(taskFromStore.site_visit_date),
        }
      : null;
  }, [taskFromStore]);

  const targetLeadId = leadId || the_task?.attachable?.id || (the_task?.attachment_type === "Lead" ? the_task?.attachment_id : null);

  useEffect(() => {
    if (taskOpen && attachment_type === "Lead" && targetLeadId && hasLeadShowPermission) {
      dispatch(getSiteVisiteDetails(targetLeadId));
      dispatch(getAllLeadNotes(targetLeadId));
    }
  }, [taskOpen, attachment_type, targetLeadId, dispatch, hasLeadShowPermission]);

  const [the_lead, setTheLead] = useState(null);
  useEffect(() => {
    if (
      taskOpen &&
      attachment_type === "Lead" &&
      leadId &&
      hasLeadShowPermission
    ) {
      dispatch(getLeadById(leadId, successGetLead));
    }
  }, [taskOpen, attachment_type, leadId, dispatch, hasLeadShowPermission]);

  const successGetLead = (data) => {
    setTheLead(data);
  };

  const { leads, isUpdateLeadLoading } = useSelector((state) => state.leads);

  const { areas } = useSelector((state) => state.areas);

  const { lead_typs } = useSelector((state) => {
    const { leads } = state;
    const { lead_typs } = leads;
    return {
      lead_typs,
    };
  });

  if (the_lead) {
    const newDate = the_lead.created_at ? the_lead.created_at.split("/") : [];
    const newDate1 = the_lead.last_communication_date
      ? the_lead.last_communication_date.split("/")
      : [];

    the_lead.created_at =
      Array.isArray(newDate) && newDate.length > 2
        ? `${newDate[2]}-${newDate[1]}-${newDate[0]}`
        : newDate[0] || "";

    the_lead.last_communication_date =
      Array.isArray(newDate1) && newDate1.length > 2
        ? `${newDate1[2]}-${newDate1[1]}-${newDate1[0]}`
        : newDate1[0] || "";

    the_lead.area_id = the_lead.area?.id || "";
  }
  // const [taskOpen, setTaskOpen] = useState(false);
  const [contactVia, setContactVia] = useState("Call");
  const [visitDate, setVisitDate] = useState(null);
  const [visitTime, setVisitTime] = useState(null);
  const [selectMultipleArea, setSelectMultipleArea] = useState([]);
  const [selectMultipleLeadTypes, SetselectMultipleLeadTypes] = useState([]);
  const [selectedValues, setSelectedValues] = useState(
    selectMultipleArea || [],
  );

  const [vastuValue, setVastuValue] = useState("No");

  const allValues = areas?.map((val) => val.id) || [];
  const isAllSelected = selectedValues.length === allValues.length;

  const [dueDateError, setDueDateError] = useState("");
  const statusColors = {
    Hot: "#E63946",
    Warm: "#F4A261",
    Cold: "#3396D3",
    Dead: "#6C757D",
    Success: "#5CB338",
  };

  function formatDate(dateStr) {
    if (!dateStr) return "";
    const parts = dateStr.split("/");
    return parts.length > 2 ? `${parts[2]}-${parts[1]}-${parts[0]}` : parts[0];
  }

  const {
    handleSubmit: handleTaskSubmit,
    errors: taskErrors,
    control: taskControl,
    reset: resetTask,
    setValue: setTaskValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: the_task || {},
  });

  const setTaskDateValue = (field, daysToAdd) => {
    const date = new Date();
    date.setDate(date.getDate() + daysToAdd);
    const formattedDate = date.toISOString().split("T")[0];
    setTaskValue(field, formattedDate, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const {
    handleSubmit: handleNoteSubmit,
    errors: noteErrors,
    control: noteControl,
    reset: resetNote,
    setValue: setNoteValue,
    getValues: getNoteValues,
  } = useForm({
    resolver: yupResolver(noteSchema),
    defaultValues: { text: "", via: "Call" },
  });

  const {
    handleSubmit: handleVisitSubmit,
    errors: visitErrors,
    control: visitControl,
    reset: resetVisit,
    setValue: setVisitValue,
    getValues: getVisitValues,
  } = useForm({
    resolver: yupResolver(siteSchema),
    defaultValues: { note: "", visit_date: null, visit_time: null },
  });

  const {
    handleSubmit: handleEditLeadSubmit,
    errors: leadErrors,
    control: leadControl,
    reset: resetLead,
    setValue: setLeadValue,
    getValues: getLeadValues,
    setError: setLeadError,
  } = useForm({
    // resolver: yupResolver(siteSchema),
    defaultValues: {
      ...the_lead,
      name: the_lead?.client?.name || "",
      type_of_client: the_lead?.client?.client_type || "",
      mobile_number: the_lead?.client?.mobile_number || "",
    },
  });

  useEffect(() => {
    if (the_lead) {
      const areaIds = the_lead?.areas_of_lead?.map((a) => a.area_id) || [];
      const leadtypes = the_lead?.types_of_lead?.types;
      const vastuComplient = the_lead?.vastu_complient === 0 ? "Yes" : "No";
      setSelectedValues(areaIds);
      setSelectMultipleArea(areaIds);
      SetselectMultipleLeadTypes(leadtypes);
      setVastuValue(vastuComplient);
    }
  }, [the_lead, leadControl]);

  useEffect(() => {
    if (the_lead) {
      resetLead({
        ...the_lead,
        name: the_lead?.client?.name || "",
        type_of_client: the_lead?.client?.client_type || "",
        mobile_number: the_lead?.client?.mobile_number || "",
      });
    }
  }, [the_lead, resetLead]);

  useEffect(() => {
    const areaIds = the_lead?.areas_of_lead?.map((a) => a.area_id) || [];
    setSelectMultipleArea(areaIds);
  }, [the_lead, leadControl]);

  useEffect(() => {
    if (the_task) {
      resetTask(the_task);
    }
  }, [the_task, resetTask]);
  const successTask = () => {
    setTaskOpen(false);
  };
  const handleOpenUT = () => {
    // if (setPopoverVisible) {
    //   setPopoverVisible(false);
    // }

    dispatch({ type: "RESET_LEAD_NOTES" });
    // dispatch(getAllLeadNotes(id));
    // dispatch(getSiteVisiteDetails(id));
    // if (setTaskOpen) {
    setTaskOpen(true);
  };

  const handleTask = (isCompleted) => {
    const updatedTaskType = !isCompleted;
    const currentDate = moment().format("DD-MM-YYYY");
    const taskDueDate = moment(taskControl.getValues("due_date")).format(
      "DD-MM-YYYY",
    );

    if (updatedTaskType) {
      if (taskDueDate < currentDate) {
        setDueDateError(
          "You cannot open this task because the due date is in the past.",
        );
        return;
      }
    }

    setDueDateError("");
    setTaskType(updatedTaskType);
    handleUpdateTask({ id, is_completed: updatedTaskType });
  };

  const NotesColumns = () => [
    {
      title: "Note",
      dataIndex: "text",
      key: "note",
      width: 150,
      render: (text) => (
        <Typography className="notesTableText">{text}</Typography>
      ),
    },
    {
      title: "Via",
      dataIndex: "contact_via",
      key: "contact_via",
      width: 90,
      render: (contact_via) => (
        <Typography className="notesTableText">{contact_via}</Typography>
      ),
    },
    {
      title: "Created by",
      dataIndex: "user",
      key: "user",
      width: 120,
      render: (user) => {
        if (!user) return "-";
        const fullName = `${user.first_name || ""} ${user.last_name || ""}`.trim();
        return (
          <Typography className="notesTableText">
            {fullName || user.name || "-"}
          </Typography>
        );
      },
    },
    {
      title: "Created date",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: (created_at) => {
        if (!created_at) return "-";
        const formattedDate = moment(created_at, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY, h:mm a");
        return (
          <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
        );
      },
    },
  ];

  const SiteVisitColumns = () => [
    {
      title: "Visit time",
      dataIndex: "visit_time",
      key: "visit_time",
      width: 100,
      render: (visit_time) => {
        if (!visit_time) return "-";
        const formattedTime = moment(visit_time).format("HH:mm"); // show 14:00
        return <div>{formattedTime}</div>;
      },
    },
    {
      title: "Visit date",
      dataIndex: "visit_date",
      key: "visit_date",
      width: 100,
      render: (visit_date) => {
        if (!visit_date) return "-";
        const formattedDate = moment(visit_date)
          .utcOffset(330)
          .format("DD/MM/YYYY");
        return (
          <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
        );
      },
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      width: 150,
      render: (note) => (
        <Typography className="notesTableText">{note}</Typography>
      ),
    },
  ];

  const handleCreateLeadNotes = (data) => {
    data.lead_id = the_task?.attachable?.id;
    data.contact_via = contactVia;
    dispatch(createLeadNotes(data, successCreateLeadNotes, failureCreateNotes));
  };

  const successCreateLeadNotes = () => {
    resetNote();
    setVisitDate(null);
    setVisitTime(null);
    dispatch(getAllLeadNotes(the_task?.attachable?.id));
  };

  const failureCreateNotes = (error) => {
    if (error?.lead && error.lead.length > 0) {
      message.error(error.lead[0]);
    } else {
      message.error("Something went wrong while creating note.");
    }
  };

  const handleCreateVisit = (data) => {
    // `data.visit_date` and `data.visit_time` come from react-hook-form now
    const date = data.visit_date; // could be null if not filled
    const time = data.visit_time; // could be null if not filled

    if (!date || !time) {
      console.warn("Date or Time missing");
      return;
    }

    const datetime = moment(
      `${date.format("YYYY-MM-DD")} ${time.format("HH:mm")}`,
      "YYYY-MM-DD HH:mm",
    ).utc();

    const payload = {
      ...data,
      visit_date: date.format("DD/MM/YYYY"),
      visit_time: datetime.format(),
      lead_id: the_task?.attachable?.id,
    };

    dispatch(createSiteVisitDetails(payload, successSiteVisit));
  };

  const successSiteVisit = () => {
    resetVisit();
    setVisitDate(null);
    setVisitTime(null);
    dispatch(getSiteVisiteDetails(the_task?.attachable?.id));
  };

  const onRowSelect = (record) => {
    console.log({ record });
  };

  const getLastElementofArray = (arr) => {
    const lengthOfArray = arr.length;
    const lastElement = arr[lengthOfArray - 1];
    return lastElement;
  };

  const handleUpdateLead = (data, event) => {
    event.preventDefault();
    data.id = leadId;
    if (!data.client) {
      data.client = {};
    }
    data.client.name = data.name;
    data.client.type_of_client = parseInt(data.type_of_client, 10) || 0;
    data.client.mobile_number = data.mobile_number;
    data.area_ids = selectMultipleArea;
    data.types_of_lead = { types: selectMultipleLeadTypes };
    data.vastu_complient = vastuValue === "Yes" ? 0 : 1;
    dispatch(
      updateLead(
        data,
        `/leads`,
        successUpdateLead,
        failureUpdateLead,
        // IsEmpty
      ),
    );
  };

  const successUpdateLead = () => {
    // resetLead();
    setTimeout(() => {
      message.success("You have successfully update lead.");
    }, 2000);
    dispatch(getAllLeads(`/leads`));
  };

  const failureUpdateLead = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
    resetLead();
  };

  const handleSelectChange = (values) => {
    if (values.includes("all")) {
      if (isAllSelected) {
        setSelectedValues([]);
        onMultipleSelectAreaHandler([]);
      } else {
        setSelectedValues(allValues);
        onMultipleSelectAreaHandler(allValues);
      }
    } else {
      setSelectedValues(values);
      onMultipleSelectAreaHandler(values);
    }
  };

  const onMultipleSelectAreaHandler = (data) => {
    setSelectMultipleArea(data);
    setLeadError("area_ids", {});
  };

  const onMultipleSelectLeadTypeHandler = (data) => {
    SetselectMultipleLeadTypes(data);
    setLeadError("types_of_lead", {});
  };

  return (
    <>
      <Button
        type="link"
        style={{ cursor: "pointer" }}
        onClick={() => handleOpenUT()}
      >
        {flag === "lead" ? "View Task" : <img src={editIcon} alt="editIcon" />}
      </Button>
      {/* <EditTwoTone
        style={{ cursor: "pointer" }}
        onClick={() => setTaskOpen(true)}
      /> */}
      {attachment_type === "Property" ? (
        <Modal
          title="Edit Task details"
          visible={taskOpen || popoverVisible}
          onCancel={() => setTaskOpen(false)}
          footer={null}
          maskClosable={false}
        >
          <form onSubmit={handleTaskSubmit(handleUpdateTask)}>
            <Spin spinning={isUpdateTaskLoading || isGetAllTaskDetailsLoading}>
              <Col>
                <Row gutter={[10, 10]}>
                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Text>Employee Name</Text>
                    <Controller
                      as={Select}
                      showSearch
                      control={taskControl}
                      options={
                        users &&
                        users.length > 0 &&
                        users.map((val, index) => {
                          return { label: val.first_name, value: val.id };
                        })
                      }
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: "100%" }}
                      name="user_id"
                    />
                    {taskErrors.user_id && (
                      <span className="error_style">
                        Employee name is required
                      </span>
                    )}
                  </Col>

                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Text>Due Date</Text>
                    <Controller
                      as={Input}
                      format="DD-MM-YYYY"
                      name="due_date"
                      control={taskControl}
                      placeholder="Due Date"
                      type="date"
                    />
                    <div style={{ marginTop: "2px", textAlign: "right" }}>
                      <Space>
                        <Button
                          className="quick-date-btn today-btn"
                          size="small"
                          onClick={() => setTaskDateValue("due_date", 0)}
                        >
                          Today
                        </Button>
                        <Button
                          className="quick-date-btn tomorrow-btn"
                          size="small"
                          onClick={() => setTaskDateValue("due_date", 1)}
                        >
                          Tomorrow
                        </Button>
                        <Button
                          className="quick-date-btn next-week-btn"
                          size="small"
                          onClick={() => setTaskDateValue("due_date", 7)}
                        >
                          Next Week
                        </Button>
                      </Space>
                    </div>
                    {taskErrors.due_date && (
                      <>
                        <span
                          className="error_style"
                          style={{ display: "block" }}
                        >
                          Due Date is required
                        </span>
                      </>
                    )}
                    {dueDateError && (
                      <span
                        className="error_style"
                        style={{ display: "block" }}
                      >
                        {dueDateError}
                      </span>
                    )}
                  </Col>

                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Text>Communication Date</Text>
                    <Controller
                      as={Input}
                      format="DD-MM-YYYY"
                      name="communication_date"
                      control={taskControl}
                      placeholder="Communication Date"
                      type="date"
                    />
                    <div style={{ marginTop: "2px", textAlign: "right" }}>
                      <Space>
                        <Button
                          className="quick-date-btn today-btn"
                          size="small"
                          onClick={() =>
                            setTaskDateValue("communication_date", 0)
                          }
                        >
                          Today
                        </Button>
                        <Button
                          className="quick-date-btn tomorrow-btn"
                          size="small"
                          onClick={() =>
                            setTaskDateValue("communication_date", 1)
                          }
                        >
                          Tomorrow
                        </Button>
                        <Button
                          className="quick-date-btn next-week-btn"
                          size="small"
                          onClick={() =>
                            setTaskDateValue("communication_date", 7)
                          }
                        >
                          Next Week
                        </Button>
                      </Space>
                    </div>
                  </Col>
                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Text>Follow up Date</Text>
                    <Controller
                      as={Input}
                      format="DD-MM-YYYY"
                      name="follow_up_date"
                      control={taskControl}
                      placeholder="Follow up Date"
                      type="date"
                    />
                    <div style={{ marginTop: "2px", textAlign: "right" }}>
                      <Space>
                        <Button
                          className="quick-date-btn today-btn"
                          size="small"
                          onClick={() => setTaskDateValue("follow_up_date", 0)}
                        >
                          Today
                        </Button>
                        <Button
                          className="quick-date-btn tomorrow-btn"
                          size="small"
                          onClick={() => setTaskDateValue("follow_up_date", 1)}
                        >
                          Tomorrow
                        </Button>
                        <Button
                          className="quick-date-btn next-week-btn"
                          size="small"
                          onClick={() => setTaskDateValue("follow_up_date", 7)}
                        >
                          Next Week
                        </Button>
                      </Space>
                    </div>
                  </Col>
                  <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Text>Site visit Date</Text>
                    <Controller
                      as={Input}
                      format="DD-MM-YYYY"
                      name="site_visit_date"
                      control={taskControl}
                      placeholder="Site visit Date"
                      type="date"
                    />
                    <div style={{ marginTop: "2px", textAlign: "right" }}>
                      <Space>
                        <Button
                          className="quick-date-btn today-btn"
                          size="small"
                          onClick={() => setTaskDateValue("site_visit_date", 0)}
                        >
                          Today
                        </Button>
                        <Button
                          className="quick-date-btn tomorrow-btn"
                          size="small"
                          onClick={() => setTaskDateValue("site_visit_date", 1)}
                        >
                          Tomorrow
                        </Button>
                        <Button
                          className="quick-date-btn next-week-btn"
                          size="small"
                          onClick={() => setTaskDateValue("site_visit_date", 7)}
                        >
                          Next Week
                        </Button>
                      </Space>
                    </div>
                  </Col>
                  <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Text>Note</Text>
                    <Controller
                      as={TextArea}
                      name="note"
                      control={taskControl}
                      rows={4}
                      showCount
                      maxLength={100}
                    />
                    {taskErrors.note && (
                      <span className="error_style">Note is required</span>
                    )}
                  </Col>
                  <Col span={24}>
                    <Row gutter={[10, 10]} justify="end">
                      <Col>
                        <Button
                          type="primary"
                          block
                          style={{
                            marginTop: 15,
                            top: 5,
                            background: the_task?.is_completed
                              ? "#5B913B"
                              : "#EE4E4E",
                          }}
                          onClick={() => handleTask(the_task?.is_completed)}
                        >
                          {the_task?.is_completed ? "Open Task" : "Close Task"}
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          style={{ marginTop: 15, top: 5 }}
                        >
                          Update Task
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Spin>
          </form>
        </Modal>
      ) : (
        <Modal
          // title="Edit Task details"
          open={taskOpen}
          onCancel={() => setTaskOpen(false)}
          footer={null}
          maskClosable={false}
          width={600}
        >
          <Tabs defaultActiveKey="1">
            {/* TAB 1: Lead details */}
            {flag === "lead" ? (
              <TabPane
                tab={<span className="leadTab">View Lead Details</span>}
                key="1"
              >
                <div style={{ position: "relative" }}>
                  <div
                    style={{
                      filter: hasLeadShowPermission ? "none" : "blur(4px)",
                      pointerEvents: hasLeadShowPermission ? "auto" : "none",
                      userSelect: hasLeadShowPermission ? "auto" : "none",
                    }}
                  >
                    <Row gutter={[0, 15]}>
                      <Col span={24}>
                        <Typography className="viewProjectHeading">
                          Client Information
                        </Typography>
                        <Row gutter={[0, 8]} className="viewProjectRow">
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Client:{" "}
                              <span className="viewLeadText">
                                {maskSensitiveVal(taskFromStore?.client_name)}
                              </span>
                            </Typography>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Budget:{" "}
                              <span className="viewLeadText">
                                {hasLeadShowPermission
                                  ? `${taskFromStore?.attachable?.min_budget || 0}`.replace(
                                      /\B(?=(\d{3})+(?!\d))/g,
                                      ",",
                                    ) +
                                    " - " +
                                    `${taskFromStore?.attachable?.max_budget || 0}`.replace(
                                      /\B(?=(\d{3})+(?!\d))/g,
                                      ",",
                                    )
                                  : "••••••••"}
                              </span>
                            </Typography>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Lead Status:{" "}
                              <span className="viewLeadText"></span>
                              <span
                                className="viewLeadText"
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                              >
                                {hasLeadShowPermission && (
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: 8,
                                      height: 8,
                                      borderRadius: "50%",
                                      backgroundColor:
                                        statusColors[
                                          taskFromStore?.attachable
                                            ?.lead_status || "#000"
                                        ],
                                      marginRight: 6,
                                    }}
                                  ></span>
                                )}
                                {maskSensitiveVal(
                                  taskFromStore?.attachable?.lead_status,
                                )}
                              </span>
                            </Typography>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Details:{" "}
                              <span className="viewLeadText">
                                {hasLeadShowPermission
                                  ? taskFromStore?.attachable?.details
                                    ? taskFromStore?.attachable?.details
                                        .split("\n")
                                        .map((line, index) => (
                                          <React.Fragment key={index}>
                                            {line || "-"}
                                            <br />
                                          </React.Fragment>
                                        ))
                                    : ""
                                  : "••••••••"}
                              </span>
                            </Typography>
                          </Col>
                        </Row>
                      </Col>

                      <Col span={24}>
                        <Typography className="viewProjectHeading">
                          Property Details
                        </Typography>
                        <Row gutter={[0, 8]} className="viewProjectRow">
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Constuction After:{" "}
                              <span className="viewLeadText">
                                {maskSensitiveVal(
                                  taskFromStore?.attachable?.construction_after,
                                )}
                              </span>
                            </Typography>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Areas:{" "}
                              <span className="viewLeadText">
                                {hasLeadShowPermission
                                  ? taskFromStore?.attachable?.areas_of_lead?.map(
                                      (area) =>
                                        area?.area_name +
                                        `${
                                          getLastElementofArray(
                                            taskFromStore?.attachable
                                              ?.areas_of_lead,
                                          )?.area_name === area?.area_name
                                            ? ""
                                            : ", "
                                        }`,
                                    )
                                  : "••••••••"}
                              </span>
                            </Typography>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Lead Type:{" "}
                              <span className="viewLeadText">
                                {hasLeadShowPermission
                                  ? taskFromStore?.attachable?.types_of_lead?.types?.map(
                                      (type) =>
                                        type +
                                        `${
                                          getLastElementofArray(
                                            taskFromStore?.attachable
                                              ?.types_of_lead?.types,
                                          ) === type
                                            ? ""
                                            : ", "
                                        }`,
                                    )
                                  : "••••••••"}
                              </span>
                            </Typography>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Vastu Complient:{" "}
                              <span className="viewLeadText">
                                {hasLeadShowPermission
                                  ? taskFromStore?.attachable
                                      ?.vastu_complient === 0
                                    ? "Yes"
                                    : "No"
                                  : "••••••••"}
                              </span>
                            </Typography>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Facing:{" "}
                              <span className="viewLeadText">
                                {maskSensitiveVal(
                                  taskFromStore?.attachable?.facing,
                                )}
                              </span>
                            </Typography>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Is Residential/Commercial/Plot?:{" "}
                              <span className="viewLeadText">
                                {maskSensitiveVal(
                                  taskFromStore?.attachable?.is_lead,
                                )}
                              </span>
                            </Typography>
                          </Col>

                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Is New/Resell/Rent/Lease?:{" "}
                              <span className="viewLeadText">
                                {maskSensitiveVal(
                                  taskFromStore?.attachable?.deal_for,
                                )}
                              </span>
                            </Typography>
                          </Col>
                        </Row>
                      </Col>

                      <Col span={24}>
                        <Typography className="viewProjectHeading">
                          Property Size
                        </Typography>
                        <Row gutter={[0, 8]} className="viewProjectRow">
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Minimum SqFt:{" "}
                              <span className="viewLeadText">
                                {maskSensitiveVal(
                                  taskFromStore?.attachable
                                    ?.lead_area_attributes?.minimum_sqFt,
                                )}
                              </span>
                            </Typography>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Typography className="viewLeadTitle">
                              Maximum SqFt:{" "}
                              <span className="viewLeadText">
                                {maskSensitiveVal(
                                  taskFromStore?.attachable
                                    ?.lead_area_attributes?.maximum_sqFt,
                                )}
                              </span>
                            </Typography>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  {!hasLeadShowPermission && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(255, 255, 255, 0.7)",
                        zIndex: 10,
                        borderRadius: "8px",
                        cursor: "not-allowed",
                      }}
                    >
                      <Typography.Text
                        strong
                        style={{ fontSize: "14px", color: "#ff4d4f" }}
                      >
                        You do not have permission to view lead details.
                      </Typography.Text>
                    </div>
                  )}
                </div>
              </TabPane>
            ) : (
              <TabPane
                tab={<span className="leadTab">Edit Lead Details</span>}
                key="1"
              >
                <div style={{ position: "relative" }}>
                  <div
                    style={{
                      filter: hasLeadShowPermission ? "none" : "blur(4px)",
                      pointerEvents:
                        hasLeadShowPermission && hasLeadEditPermission
                          ? "auto"
                          : "none",
                      userSelect: hasLeadShowPermission ? "auto" : "none",
                    }}
                  >
                    <form onSubmit={handleEditLeadSubmit(handleUpdateLead)}>
                      <Spin
                        spinning={isUpdateLeadLoading || isGetLeadByIdLoading}
                      >
                        <Row
                          gutter={[8, 16]}
                          style={{ pointerEvents: "none", opacity: "0.6" }}
                        >
                          <Col span={24}></Col>
                          <Col xl={8} lg={8} md={8} sm={24} xs={24}>
                            <Row>
                              <Text>Client name</Text>
                            </Row>
                            <Controller
                              as={Input}
                              name="name"
                              control={leadControl}
                              placeholder="Enter client name"
                            />
                          </Col>
                          <Col
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                            // style={{ display: current === 0 ? "block" : "none" }}
                          >
                            <Row>
                              <Text>Client Type</Text>
                            </Row>
                            <Controller
                              as={Select}
                              control={leadControl}
                              options={ClientType}
                              style={{ width: "100%" }}
                              name="type_of_client"
                            />
                          </Col>
                          <Col
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                            // style={{ display: current === 0 ? "block" : "none" }}
                          >
                            <Row>
                              <Text>Client Mobile number</Text>
                            </Row>
                            <Controller
                              name="mobile_number"
                              control={leadControl}
                              rules={{
                                required: true,
                                minLength: 10,
                                maxLength: 10,
                              }}
                              render={({ value, onChange }) => (
                                <Input
                                  value={value}
                                  onChange={(e) => onChange(e.target.value)}
                                  maxLength={10}
                                  placeholder="Enter mobile number"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row gutter={[8, 16]}>
                          <Col span={24}></Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Zone</Text>
                            </Row>
                            <Controller
                              as={Select}
                              control={leadControl}
                              options={Zone}
                              name="zone"
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Areas</Text>
                            </Row>
                            <Controller
                              control={leadControl}
                              defaultValue={[]}
                              name="area_ids"
                              render={({ field }) => (
                                <Select
                                  mode="multiple"
                                  value={selectedValues}
                                  placeholder="Select areas"
                                  style={{ width: "100%" }}
                                  onChange={handleSelectChange}
                                  filterOption={(input, option) =>
                                    option.label
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                  dropdownRender={(menu) => (
                                    <>
                                      <div
                                        style={{
                                          padding: "5px 12px",
                                          borderBottom: "1px solid #f0f0f0",
                                        }}
                                      >
                                        <Checkbox
                                          onChange={() =>
                                            handleSelectChange(["all"])
                                          }
                                          checked={isAllSelected}
                                        >
                                          Select All
                                        </Checkbox>
                                      </div>
                                      {menu}
                                    </>
                                  )}
                                  options={[
                                    ...(areas?.map((val) => ({
                                      label: val.name,
                                      value: val.id,
                                    })) || []),
                                  ]}
                                />
                              )}
                            />
                            {leadErrors?.area_ids?.types?.required && (
                              <span className="error_style">
                                Area is required
                              </span>
                            )}
                          </Col>

                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Lead Types</Text>
                            </Row>
                            <Controller
                              control={leadControl}
                              defaultValue={[]}
                              render={({ field }) => (
                                <Select
                                  mode="multiple"
                                  showSearch={false}
                                  value={selectMultipleLeadTypes}
                                  options={lead_typs}
                                  placeholder="select lead types"
                                  style={{ width: "100%" }}
                                  onChange={(value) =>
                                    onMultipleSelectLeadTypeHandler(value)
                                  }
                                />
                              )}
                              name="types_of_lead"
                            />
                            {leadErrors?.types_of_lead?.types?.required && (
                              <span className="error_style">
                                Lead Type is required
                              </span>
                            )}
                          </Col>
                        </Row>
                        <Row gutter={[8, 16]}>
                          <Col span={24}></Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Last Communication Date</Text>
                            </Row>
                            <Controller
                              as={Input}
                              name="last_communication_date"
                              control={leadControl}
                              placeholder="Last Communication Date"
                              type="date"
                              format="DD-MM-YYYY"
                            />
                            {leadErrors.created_at && (
                              <span className="error_style">
                                Last Communication Date is required
                              </span>
                            )}
                          </Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Entry Date</Text>
                            </Row>
                            <Controller
                              as={Input}
                              name="created_at"
                              control={leadControl}
                              placeholder="Entry Date"
                              type="date"
                              format="DD-MM-YYYY"
                            />
                            {leadErrors.created_at && (
                              <span className="error_style">
                                Entry Date is required
                              </span>
                            )}
                          </Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}

                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Bhk</Text>
                            </Row>
                            <Controller
                              as={Input}
                              name="bhk"
                              control={leadControl}
                              placeholder="Total Bhk"
                              type="number"
                            />
                            {leadErrors.bhk && (
                              <span className="error_style">
                                Bhk is required
                              </span>
                            )}
                          </Col>
                        </Row>

                        <Row gutter={[8, 16]}>
                          <Col span={24}></Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Facing</Text>
                            </Row>
                            <Controller
                              as={Input}
                              name="facing"
                              control={leadControl}
                              placeholder="Facing"
                            />
                          </Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Minimum Budget</Text>
                            </Row>
                            <Controller
                              name="min_budget"
                              control={leadControl}
                              render={(props) => (
                                <InputNumber
                                  style={{ width: "100%" }}
                                  formatter={(value) =>
                                    value
                                      ? `₹ ${new Intl.NumberFormat(
                                          "en-IN",
                                        ).format(value)}`
                                      : "₹ "
                                  }
                                  parser={(value) =>
                                    value.replace(/₹\s?|(,*)/g, "")
                                  }
                                  {...props}
                                />
                              )}
                            />
                            {leadErrors.min_budget && (
                              <span className="error_style">
                                Minimum Budget is required
                              </span>
                            )}
                          </Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Maximum Budget</Text>
                            </Row>
                            <Controller
                              name="max_budget"
                              control={leadControl}
                              render={(props) => (
                                <InputNumber
                                  style={{ width: "100%" }}
                                  formatter={(value) =>
                                    value
                                      ? `₹ ${new Intl.NumberFormat(
                                          "en-IN",
                                        ).format(value)}`
                                      : "₹ "
                                  }
                                  parser={(value) =>
                                    value.replace(/₹\s?|(,*)/g, "")
                                  }
                                  {...props}
                                />
                              )}
                            />
                            {leadErrors.max_budget && (
                              <span className="error_style">
                                Maximum Budget is required
                              </span>
                            )}
                          </Col>
                        </Row>
                        <Row gutter={[8, 16]}>
                          <Col span={24}></Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Typography>Vastu Compliance</Typography>
                            <ConfigProvider
                              theme={{
                                components: {
                                  Segmented: {
                                    itemActiveBg: "none",
                                    itemColor: "none",
                                    itemSelectedBg: "#c0cdf2",
                                    itemSelectedColor: "#000",
                                    itemHoverBg: "none",
                                    itemHoverColor: "none",
                                  },
                                },
                              }}
                            >
                              <Segmented
                                options={["Yes", "No"]}
                                value={vastuValue}
                                onChange={setVastuValue}
                                block
                                className="segmentedForm"
                              />
                            </ConfigProvider>

                            {leadErrors.vastu_complient && (
                              <span className="error_style">
                                Vastu Complient is required
                              </span>
                            )}
                          </Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Construction After</Text>
                            </Row>
                            <Controller
                              as={Input}
                              name="construction_after"
                              control={leadControl}
                              placeholder="Construction After"
                            />
                            {leadErrors.construction_after && (
                              <span className="error_style">
                                Construction After is required
                              </span>
                            )}
                          </Col>
                          <Col
                            // style={{ display: current === 0 ? "block" : "none" }}
                            xl={16}
                            lg={16}
                            md={16}
                            sm={24}
                            xs={24}
                          >
                            <Row gutter={[30, 16]}>
                              <Col span={24}></Col>
                              <Col>
                                <Row gutter={[10, 0]}>
                                  <Col>
                                    <Text>New</Text>
                                  </Col>
                                  <Col>
                                    <Controller
                                      name="is_new"
                                      control={leadControl}
                                      render={(props) => (
                                        <Checkbox
                                          {...props}
                                          checked={props.value}
                                          onChange={(e) =>
                                            props.onChange(e.target.checked)
                                          }
                                        />
                                      )}
                                    />
                                  </Col>
                                </Row>
                              </Col>

                              <Col>
                                <Row gutter={[10, 0]}>
                                  <Col>
                                    <Text>Urgent</Text>
                                  </Col>
                                  <Col>
                                    <Controller
                                      name="is_urgent"
                                      control={leadControl}
                                      render={(props) => (
                                        <Checkbox
                                          {...props}
                                          checked={props.value}
                                          onChange={(e) =>
                                            props.onChange(e.target.checked)
                                          }
                                        />
                                      )}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row gutter={[10, 0]}>
                                  <Col>
                                    <Text>Resell</Text>
                                  </Col>
                                  <Col>
                                    <Controller
                                      name="is_resell"
                                      control={leadControl}
                                      render={(props) => (
                                        <Checkbox
                                          {...props}
                                          checked={props.value}
                                          onChange={(e) =>
                                            props.onChange(e.target.checked)
                                          }
                                        />
                                      )}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row>
                          <Col
                            style={{ marginTop: "20px" }}
                            xl={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                          >
                            {" "}
                            <Text>Details</Text>
                            <Controller
                              as={TextArea}
                              name="details"
                              control={leadControl}
                              rows={4}
                              showCount
                              maxLength={10000}
                            />
                            {leadErrors.details && (
                              <span className="error_style">
                                Details is required
                              </span>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            style={{
                              // display: current === 1 ? "block" : "none",
                              marginTop: "10px",
                            }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Lead Status</Text>
                            </Row>
                            <Controller
                              as={Select}
                              control={leadControl}
                              options={LeadStatus}
                              name="lead_status"
                              style={{ width: "100%" }}
                            />
                            {leadErrors.lead_status && (
                              <span className="error_style">
                                Lead Status is required
                              </span>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            // style={{ display: current === 1 ? "block" : "none" }}
                            xl={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                          >
                            <Divider plain>Lead Area</Divider>
                          </Col>
                        </Row>
                        <Row gutter={[8, 24]}>
                          <Col span={24}></Col>
                          <Col
                            // style={{ display: current === 1 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Minimum Area</Text>
                            </Row>
                            <Controller
                              as={Input}
                              name="lead_area_attributes[minimum_sqFt]"
                              type="number"
                              control={leadControl}
                              placeholder="Minimum Area"
                            />
                          </Col>
                          <Col
                            // style={{ display: current === 1 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Maximum Area</Text>
                            </Row>
                            <Controller
                              as={Input}
                              name="lead_area_attributes[maximum_sqFt]"
                              type="number"
                              control={leadControl}
                              placeholder="Maximum Area"
                            />
                          </Col>
                          <Col
                            // style={{ display: current === 1 ? "block" : "none" }}
                            xl={8}
                            lg={8}
                            md={8}
                            sm={24}
                            xs={24}
                          >
                            <Row>
                              <Text>Lead Area Type</Text>
                            </Row>
                            <Controller
                              as={Select}
                              control={leadControl}
                              options={LeadAreaType}
                              name="lead_area_type"
                              style={{ width: "100%" }}
                            />
                            {leadErrors.lead_area_type && (
                              <span className="error_style">
                                Lead Area Type is required
                              </span>
                            )}
                          </Col>
                        </Row>

                        <Row justify={"end"}>
                          <Col style={{ marginTop: "10px" }}>
                            {/* {isUpdateLeadLoading ? (
                        <Spin
                          indicator={
                            <LoadingOutlined
                              style={{
                                fontSize: 24,
                              }}
                              spin
                            />
                          }
                        />
                      ) : ( */}
                            <Button
                              type="primary"
                              htmlType="submit"
                              disabled={!hasLeadEditPermission}
                            >
                              Update
                            </Button>
                            {/* )} */}
                          </Col>
                        </Row>
                      </Spin>
                    </form>
                  </div>
                  {!hasLeadShowPermission && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(255, 255, 255, 0.7)",
                        zIndex: 10,
                        borderRadius: "8px",
                      }}
                    >
                      <Typography.Text
                        strong
                        style={{ fontSize: "14px", color: "#ff4d4f" }}
                      >
                        You do not have permission to view lead details.
                      </Typography.Text>
                    </div>
                  )}
                </div>
              </TabPane>
            )}

            {/* TAB 2: Task details */}
            {/* <TabPane
              tab={
                flag === "lead" ? (
                  <span className="leadTab">View Task Details</span>
                ) : (
                  <span className="leadTab">Edit Task Details</span>
                )
              }
              key="2"
              style={{ pointerEvents: flag === "lead" ? "none" : "auto" }}
            >
              <Row gutter={[0, 15]}>
                <Col span={24}>
                  <Typography className="viewProjectHeading">
                    Client Information
                  </Typography>
                  <Row gutter={[0, 8]} className="viewProjectRow">
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Client:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.client_name}
                        </span>
                      </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Budget:{" "}
                        <span className="viewLeadText">
                          {`₹ ${taskFromStore?.attachable?.min_budget}`.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                          )}{" "}
                          -{" "}
                          {`${taskFromStore?.attachable?.max_budget}`.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                          )}
                        </span>
                      </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Lead Status: <span className="viewLeadText"></span>
                        <span
                          className="viewLeadText"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              backgroundColor:
                                statusColors[
                                  taskFromStore?.attachable?.lead_status || "#000"
                                ],
                              marginRight: 6,
                            }}
                          ></span>
                          {
                            taskFromStore?.attachable?.lead_status
                          }
                        </span>
                      </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Details:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.details
                            ? taskFromStore?.attachable?.details
                                .split("\n")
                                .map((line, index) => (
                                  <React.Fragment key={index}>
                                    {line || "-"}
                                    <br />
                                  </React.Fragment>
                                ))
                            : ""}
                        </span>
                      </Typography>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Typography className="viewProjectHeading">
                    Property Details
                  </Typography>
                  <Row gutter={[0, 8]} className="viewProjectRow">
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Constuction After:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.construction_after || "-"}
                        </span>
                      </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Areas:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.areas_of_lead?.map(
                            (area) =>
                              area?.area_name +
                              `${
                                getLastElementofArray(
                                  taskFromStore?.attachable?.areas_of_lead
                                )?.area_name === area?.area_name
                                  ? ""
                                  : ", "
                              }`
                          )}
                        </span>
                      </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Lead Type:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.types_of_lead?.types?.map(
                            (type) =>
                              type +
                              `${
                                getLastElementofArray(
                                  taskFromStore?.attachable?.types_of_lead
                                    ?.types
                                ) === type
                                  ? ""
                                  : ", "
                              }`
                          )}
                        </span>
                      </Typography>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Vastu Complient:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.vastu_complient === 0
                            ? "Yes"
                            : "No"}
                        </span>
                      </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Facing:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.facing || "-"}
                        </span>
                      </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Is Residential/Commercial/Plot?:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.is_lead || "-"}
                        </span>
                      </Typography>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Is New/Resell/Rent/Lease?:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.deal_for || "-"}
                        </span>
                      </Typography>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Typography className="viewProjectHeading">
                    Property Size
                  </Typography>
                  <Row gutter={[0, 8]} className="viewProjectRow">
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Minimum SqFt:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.lead_area_attributes
                            ?.minimum_sqFt || "-"}
                        </span>
                      </Typography>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Typography className="viewLeadTitle">
                        Maximum SqFt:{" "}
                        <span className="viewLeadText">
                          {taskFromStore?.attachable?.lead_area_attributes
                            ?.maximum_sqFt || "-"}
                        </span>
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </TabPane> */}

            {/* TAB 2: Task details */}
            <TabPane
              tab={
                flag === "lead" ? (
                  <span className="leadTab">View Task Details</span>
                ) : (
                  <span className="leadTab">Edit Task Details</span>
                )
              }
              key="2"
              style={{ pointerEvents: flag === "lead" ? "none" : "auto" }}
            >
              <form onSubmit={handleTaskSubmit(handleUpdateTask)}>
                <Spin
                  spinning={isUpdateTaskLoading || isGetAllTaskDetailsLoading}
                >
                  <Col>
                    <Row gutter={[10, 10]}>
                      {/* Employee Name */}
                      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Text>Employee Name</Text>
                        <Controller
                          as={Select}
                          showSearch
                          control={taskControl}
                          options={
                            users &&
                            users.length > 0 &&
                            users.map((val) => ({
                              label: val.first_name,
                              value: val.id,
                            }))
                          }
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          style={{ width: "100%" }}
                          name="user_id"
                        />
                        {taskErrors.user_id && (
                          <span className="error_style">
                            Employee name is required
                          </span>
                        )}
                      </Col>

                      {/* Due Date */}
                      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Text>Due Date</Text>
                        <Controller
                          as={Input}
                          format="DD-MM-YYYY"
                          name="due_date"
                          control={taskControl}
                          placeholder="Due Date"
                          type="date"
                        />
                        <div style={{ marginTop: "2px" }}>
                          <Space>
                            <Button
                              className="quick-date-btn today-btn"
                              size="small"
                              onClick={() => setTaskDateValue("due_date", 0)}
                            >
                              Today
                            </Button>
                            <Button
                              className="quick-date-btn tomorrow-btn"
                              size="small"
                              onClick={() => setTaskDateValue("due_date", 1)}
                            >
                              Tomorrow
                            </Button>
                            <Button
                              className="quick-date-btn next-week-btn"
                              size="small"
                              onClick={() => setTaskDateValue("due_date", 7)}
                            >
                              Next Week
                            </Button>
                          </Space>
                        </div>
                        {taskErrors.due_date && (
                          <span
                            className="error_style"
                            style={{ display: "block" }}
                          >
                            Due Date is required
                          </span>
                        )}
                        {dueDateError && (
                          <span
                            className="error_style"
                            style={{ display: "block" }}
                          >
                            {dueDateError}
                          </span>
                        )}
                      </Col>

                      {/* Communication Date */}
                      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Text>Communication Date</Text>
                        <Controller
                          as={Input}
                          format="DD-MM-YYYY"
                          name="communication_date"
                          control={taskControl}
                          placeholder="Communication Date"
                          type="date"
                        />
                        <div style={{ marginTop: "5px" }}>
                          <Space>
                            <Button
                              className="quick-date-btn today-btn"
                              size="small"
                              onClick={() =>
                                setTaskDateValue("communication_date", 0)
                              }
                            >
                              Today
                            </Button>
                            <Button
                              className="quick-date-btn tomorrow-btn"
                              size="small"
                              onClick={() =>
                                setTaskDateValue("communication_date", 1)
                              }
                            >
                              Tomorrow
                            </Button>
                            <Button
                              className="quick-date-btn next-week-btn"
                              size="small"
                              onClick={() =>
                                setTaskDateValue("communication_date", 7)
                              }
                            >
                              Next Week
                            </Button>
                          </Space>
                        </div>
                      </Col>

                      {/* Follow up Date */}
                      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Text>Follow up Date</Text>
                        <Controller
                          as={Input}
                          format="DD-MM-YYYY"
                          name="follow_up_date"
                          control={taskControl}
                          placeholder="Follow up Date"
                          type="date"
                        />
                        <div style={{ marginTop: "5px" }}>
                          <Space>
                            <Button
                              className="quick-date-btn today-btn"
                              size="small"
                              onClick={() =>
                                setTaskDateValue("follow_up_date", 0)
                              }
                            >
                              Today
                            </Button>
                            <Button
                              className="quick-date-btn tomorrow-btn"
                              size="small"
                              onClick={() =>
                                setTaskDateValue("follow_up_date", 1)
                              }
                            >
                              Tomorrow
                            </Button>
                            <Button
                              className="quick-date-btn next-week-btn"
                              size="small"
                              onClick={() =>
                                setTaskDateValue("follow_up_date", 7)
                              }
                            >
                              Next Week
                            </Button>
                          </Space>
                        </div>
                      </Col>

                      {/* Site visit Date */}
                      {/* <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Text>Site visit Date</Text>
                        <Controller
                          as={Input}
                          format="DD-MM-YYYY"
                          name="site_visit_date"
                          control={taskControl}
                          placeholder="Site visit Date"
                          type="date"
                        />
                        <div style={{ marginTop: "5px" }}>
                          <Space>
                            <Button className="quick-date-btn today-btn" size="small" onClick={() => setTaskDateValue("site_visit_date", 0)}>Today</Button>
                            <Button className="quick-date-btn tomorrow-btn" size="small" onClick={() => setTaskDateValue("site_visit_date", 1)}>Tomorrow</Button>
                            <Button className="quick-date-btn next-week-btn" size="small" onClick={() => setTaskDateValue("site_visit_date", 7)}>Next Week</Button>
                          </Space>
                        </div>
                      </Col> */}

                      {/* Notes */}
                      {/* <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Text>Note</Text>
                    <Controller
                      as={TextArea}
                      name="note"
                      control={control}
                      rows={4}
                      showCount
                      maxLength={100}
                    />
                    {errors.note && (
                      <span className="error_style">Note is required</span>
                    )}
                  </Col> */}

                      {/* Buttons */}
                      {flag === "lead" ? (
                        ""
                      ) : (
                        <Col span={24}>
                          <Row gutter={[10, 10]} justify="end">
                            <Col>
                              <Button
                                type="primary"
                                block
                                style={{
                                  marginTop: 15,
                                  top: 5,
                                  background: the_task?.is_completed
                                    ? "#5B913B"
                                    : "#EE4E4E",
                                }}
                                onClick={() =>
                                  handleTask(the_task?.is_completed)
                                }
                              >
                                {the_task?.is_completed
                                  ? "Open Task"
                                  : "Close Task"}
                              </Button>
                            </Col>
                            <Col>
                              <Button
                                type="primary"
                                htmlType="submit"
                                block
                                style={{ marginTop: 15, top: 5 }}
                              >
                                Update Task
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Spin>
              </form>
            </TabPane>

            {/* TAB 3: Notes details */}
            <TabPane
              tab={<span className="leadTab">Note Details</span>}
              key="3"
            >
              {/* Notes List */}
              <div style={{ height: "200px", overflowY: "auto" }}>
                <MyTable
                  columns={NotesColumns()}
                  data={Array.isArray(leadNotes) ? leadNotes : leadNotes?.lead_notes || []}
                  onRowSelect={(record) => onRowSelect(record)}
                />
              </div>
              <div style={{ display: flag === "lead" ? "none" : "block" }}>
                <Spin
                  spinning={isCreateLeadNotesLoading || isGetLeadNotesLoading}
                >
                  <form onSubmit={handleNoteSubmit(handleCreateLeadNotes)}>
                    <div style={{ marginTop: 16 }}>
                      <Typography className="note">Note</Typography>
                      <Controller
                        name="text"
                        control={noteControl}
                        defaultValue=""
                        as={TextArea}
                        rows={4}
                      />
                      {noteErrors.text && (
                        <span className="error_style">Note is required</span>
                      )}

                      {/* Quick Actions */}
                      <Space style={{ marginTop: 10 }}>
                        <Button
                          className="notesText"
                          onClick={() => {
                            const current = getNoteValues("text") || "";
                            const toAdd = "Did not answered";
                            setNoteValue(
                              "text",
                              current ? current + " " + toAdd : toAdd,
                            );
                          }}
                        >
                          Did not answered
                        </Button>

                        <Button
                          className="notesText"
                          onClick={() => {
                            const current = getNoteValues("text") || "";
                            const toAdd = "Contact next week";
                            setNoteValue(
                              "text",
                              current ? current + " " + toAdd : toAdd,
                            );
                          }}
                        >
                          Contact next week
                        </Button>
                      </Space>

                      {/* Contacted via */}
                      <div style={{ marginTop: 12 }}>
                        <Text className="note">Contacted via:</Text>
                        <Radio.Group
                          style={{ marginLeft: 10 }}
                          value={contactVia}
                          onChange={(e) => setContactVia(e.target.value)}
                        >
                          <Radio value="Call" className="note">
                            Call
                          </Radio>
                          <Radio value="Message" className="note">
                            Message
                          </Radio>
                        </Radio.Group>{" "}
                      </div>

                      {/* Add New Note Button */}

                      <div
                        style={{
                          marginTop: 15,
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ fontFamily: "Roboto-400" }}
                        >
                          Add new note
                        </Button>
                      </div>
                    </div>
                  </form>
                </Spin>
              </div>
            </TabPane>

            {/* TAB 4: Site visit details */}
            <TabPane
              tab={<span className="leadTab">Site Visit Details</span>}
              key="4"
            >
              <div style={{ height: "200px", overflowY: "auto" }}>
                <MyTable
                  columns={SiteVisitColumns()}
                  data={Array.isArray(siteVisitDetails) ? siteVisitDetails : siteVisitDetails?.site_visit_details || []}
                />
              </div>
              <div style={{ display: flag === "lead" ? "none" : "block" }}>
                <Spin
                  spinning={
                    isGetSiteVisitDetailsLoading ||
                    isCreateSiteVisitDetailsLoading
                  }
                >
                  <form onSubmit={handleVisitSubmit(handleCreateVisit)}>
                    <Row gutter={16} style={{ marginTop: 16 }}>
                      {/* Visit Time */}
                      <Col xs={24} sm={12}>
                        <Typography className="note">Visit time</Typography>
                        <Controller
                          name="visit_time"
                          control={visitControl}
                          defaultValue={null}
                          render={({ onChange, value }) => (
                            <TimePicker
                              value={value ?? null}
                              onChange={onChange}
                              format="HH:mm"
                              placeholder="Select time"
                              style={{ width: "100%" }}
                            />
                          )}
                        />
                        {visitErrors.visit_time && (
                          <span className="error_style">
                            {visitErrors.visit_time.message}
                          </span>
                        )}
                      </Col>

                      {/* Visit Date */}
                      <Col xs={24} sm={12}>
                        <Typography className="note">Visit date</Typography>
                        <Controller
                          name="visit_date"
                          control={visitControl}
                          defaultValue={null}
                          render={({ onChange, value }) => (
                            <DatePicker
                              value={value ?? null}
                              onChange={onChange}
                              format="DD-MM-YYYY"
                              placeholder="dd-mm-yyyy"
                              style={{ width: "100%" }}
                            />
                          )}
                        />
                        {visitErrors.visit_date && (
                          <span className="error_style">
                            Visit date is required
                          </span>
                        )}
                      </Col>
                    </Row>

                    {/* Note */}
                    <div style={{ marginTop: 16 }}>
                      <Typography className="note">Note</Typography>
                      <Controller
                        name="note"
                        control={visitControl}
                        defaultValue=""
                        as={TextArea}
                        rows={4}
                      />
                      {visitErrors.note && (
                        <span className="error_style">Note is required</span>
                      )}
                    </div>

                    {/* Submit Button */}
                    {flag === "lead" ? (
                      ""
                    ) : (
                      <div
                        style={{
                          marginTop: 15,
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ fontFamily: "Roboto-400" }}
                        >
                          Save visit
                        </Button>
                      </div>
                    )}
                  </form>
                </Spin>
              </div>
            </TabPane>
          </Tabs>
        </Modal>
      )}
    </>
  );
};
